export default __webpack_public_path__ + "static/media/defaultCoin.d986cf13.svg";